import { TFunction } from "i18next";

/** Translates dotted API error keys via the current i18n locale (`t`). */
export const translateErrorMessageText = (
  errorMessage: string,
  t: TFunction
): string => {
  const errorDescriptionArray = errorMessage.trim().split(".");
  const translatedError: string[] = errorDescriptionArray.map((err) => {
    const trimmedError = err.trim();
    if (!trimmedError) return "";

    const errorWithDelimiter = err.trim() + ".";

    return t(errorWithDelimiter);
  });
  return translatedError.join(" ");
};

/**
 * Localizes API error text that may contain multiple lines (e.g. message + details).
 * Each line is passed through {@link translateErrorMessageText} so bundle keys stay stable.
 */
export function getLocalizedApiErrorMessage(
  errorMessage: string,
  t: TFunction
): string {
  return errorMessage
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => translateErrorMessageText(line, t))
    .join("\n");
}
